module.exports = __webpack_public_path__ + "5c79e149e5a3dbaba2a42ba1897a30ba.MP3";